'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDestination = function () {
    function WinresDestination($scope, urlService, departureService, localizationService) {
        _classCallCheck(this, WinresDestination);

        this.$scope = $scope;
        this.urlService = urlService;
        this.departureService = departureService;
        this.localizationService = localizationService;
    }

    _createClass(WinresDestination, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Destination code for current page.
            this.winresReservationContext.$scope.destinationCode = this.destinationCode;

            // Product code for current page.
            this.winresReservationContext.$scope.productCode = this.productCode;

            // Flag current page as kohdesivu.
            this.winresReservationContext.urlService.isFixedKohdeSivu = true;

            // Re-init Google analytics watches with isFixedKohdeSivu.
            this.winresReservationContext.analyticsInitWatches();

            this.$scope.$on('$locationChangeSuccess', function () {
                // this.loadDestination();
                _this.changeDestination();
            });
        }

        // loadDestination() {
        //     const searchCriteria = {
        //         'Language': this.localizationService.getLanguage(),
        //         'Offset': 0,
        //         'BeginDate': moment().format('YYYY-MM-DD'), // This day.
        //         'EndDate': moment().add(1, 'days').format('YYYY-MM-DD'),
        //         'DestCode': this.destinationCode,
        //         'ProdCode': this.productCode,
        //         'NumAdults': 2,
        //         'NumChildren': 0,
        //         'NumInfants': 0,
        //         'NumRooms': 1,
        //         'IgnoreCapacity': true,
        //         'IgnoreMissingPrice': true,
        //         'Limit': 1
        //     }

        //     this.departureService.searchDayCapacity(searchCriteria).then(result => {
        //         if (result.Results[0] != null) {
        //             this.changeDestination();
        //         }
        //     }, error => {
        //         // Search again with different dates to ignore forbidden dates.
        //         // TODO: Add flag to SearchDayCapacity which ignores forbidden dates.
        //         searchCriteria.BeginDate = moment().add(2, 'days').format('YYYY-MM-DD');
        //         searchCriteria.EndDate = moment().add(3, 'days').format('YYYY-MM-DD');
        //         this.departureService.searchDayCapacity(searchCriteria).then(result => {
        //             if (result.Results[0] != null) {
        //                 this.changeDestination();
        //             }
        //         });
        //     });
        // }

    }, {
        key: 'changeDestination',
        value: function changeDestination() {
            // Set next reservable begin and end date for current page.
            this.winresReservationContext.$scope.startDate = moment().format('YYYY-MM-DD');
            this.winresReservationContext.$scope.endDate = moment().add(1, 'days').format('YYYY-MM-DD');

            // Num of people.
            this.winresReservationContext.$scope.numAdults = 2;
            this.winresReservationContext.$scope.numChildren = 0;
            this.winresReservationContext.$scope.numInfants = 0;

            // Update data for destination.
            this.winresReservationContext.initUrlData();
            this.winresReservationContext.initPassengerFieldsBase();
            this.winresReservationContext.initPassengers();

            // Reset loading destination for full refresh.
            this.winresReservationContext.loadingDestination = null;

            // Load the actual destination.
            this.winresReservationContext.loadDestination();
        }
    }]);

    return WinresDestination;
}();

WinresDestination.$inject = ['$scope', 'urlService', 'departureService', 'localizationService'];

_module3.default.component('winresDestination', {
    // templateUrl: getTemplate,
    controller: WinresDestination,
    bindings: {
        // Fixed destination code for current page.
        destinationCode: '@',

        // Fixed product code for current page.
        productCode: '@'

    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestination/winresDestination.js
// module id = 516
// module chunks = 2